// 分類列表 - 內容＋列表廣告欄位
'use client';
import { useState, useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { findNewsList } from '@/app/actions';

import ListComponent from '../list/ListComponent'; // 列表新聞元件
import ListHint from '../list/ListHint'; // 合作提示
import ListAsideAd from '../advertisement/ListAsideAd'; // 側邊廣告欄位
import Pagination from '../layout/Pagination'; // 分頁功能列
import GoTop from '../layout/GoTop'; // 一鍵往上

const CategoryContentList = ({
    locale,
    banners,
    category = 'allnews',
    initList = [],
    pageCnt = 0,
    tagId,
    cookies,
    setTags = () => {},
}) => {
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const tag = searchParams.get('tag') || tagId;
    const pageParams = searchParams.get('page');

    // 目前大分類、 tagID
    const [currentCategory, setCurrentCategory] = useState(category);

    const [isMount, setIsMount] = useState(false);
    // 列表內容
    const [newsList, setNewsList] = useState(initList);
    // 頁碼
    const [pageIndex, setPageIndex] = useState(1);
    // 總頁數
    const [pageSize, setPageSize] = useState(pageCnt);

    // 取得更多新聞
    const fetchMoreNews = async (page) => {
        try {
            const { news, totalPage, tagLists } = await findNewsList({
                locale,
                page,
                category: currentCategory,
                tagId: tag,
                cookies,
            });
            if (news) {
                // 卷到最上面、設定總頁數
                setNewsList(news);
                setTags(tagLists);

                if (!pageParams) window.scrollTo({ top: 0 });
                setPageSize(totalPage);
            }
        } catch (e) {
            console.error(e);
        }
    };

    // 根據路徑調整目前大分類
    const handleLocation = () => {
        // 首頁
        if (pathname === '/' || pathname === '/cn') {
            setCurrentCategory('allnews');
            return;
        }

        const regexCategory = /(?:\/cn)?\/([^\/?]+)/;
        const matchCategory = pathname.match(regexCategory);

        // 列表頁
        if (matchCategory && matchCategory[1] !== currentCategory)
            setCurrentCategory(matchCategory[1]);
    };

    const onInit = () => {
        fetchMoreNews(1);
        setPageIndex(1);
    };

    useEffect(() => {
        if (isMount) fetchMoreNews(pageIndex);

        setIsMount(true);
    }, [pageIndex]);

    useEffect(() => {
        handleLocation();
    }, [pathname]);

    // 大分類切換
    useEffect(() => {
        if (isMount) onInit();
    }, [currentCategory, tag]);

    return (
        <div
            className={`flex gap-x-[15px] w-full px-[30px] mx-auto max-w-[1240px] usm:px-[15px]
        ${newsList?.length < 3 || pageSize < 2 ? 'pb-[50px]' : ''}`}
        >
            {/* 內容列表 */}
            <section className="space-y-[12px] flex-grow">
                {newsList?.map((item, i) => (
                    <ListComponent key={`author-list-${i}`} info={item} location="newsList" />
                ))}

                {/* 合作提示 */}
                <ListHint />

                {/* 分頁功能列 */}
                <Pagination
                    pageIndex={pageIndex}
                    setPageIndex={setPageIndex}
                    pageSize={pageSize}
                    category={currentCategory}
                />
            </section>

            <aside className="flex flex-col uxl:hidden w-[276px]">
                {/* 廣告欄位 */}
                <ListAsideAd banners={banners} />

                {/* 一鍵往上 */}
                <GoTop />
            </aside>
        </div>
    );
};

export default CategoryContentList;
